import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("pwa-dismissed")) return;
    const handler = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch { /* ignore */ }
    setShow(false); setDeferred(null);
    localStorage.setItem("pwa-dismissed", "1");
  };
  const dismiss = () => { setShow(false); localStorage.setItem("pwa-dismissed", "1"); };

  if (!show) return null;
  return (
    <div data-testid="install-prompt"
      className="fixed bottom-4 left-1/2 z-[60] flex max-w-[92vw] -translate-x-1/2 items-center gap-3 rounded-full border border-gray-200 bg-white/95 px-4 py-2.5 shadow-xl backdrop-blur">
      <span className="grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-[#002FA7] text-white"><Download size={16} /></span>
      <span className="text-sm font-semibold text-gray-800">Install RentGlobe for a faster, app-like experience</span>
      <button data-testid="install-accept" onClick={install} className="shrink-0 rounded-full bg-[#002FA7] px-4 py-1.5 text-sm font-bold text-white transition-colors hover:bg-[#002280]">Install</button>
      <button data-testid="install-dismiss" onClick={dismiss} className="grid h-7 w-7 shrink-0 place-items-center rounded-full text-gray-400 transition-colors hover:bg-gray-100"><X size={15} /></button>
    </div>
  );
}
